var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',{staticClass:"user-column"},[_c('div',{staticClass:"img-member-avatar",style:(("background-image: url('" + (_vm.value.photo_url) + "')")),attrs:{"title":_vm.value.name}}),_vm._v(" "),_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.value.name))])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06a7e0bd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/metronic/table/value/CreatedBy.vue
// module id = NKZA
// module chunks = 0 1 2